import {
  UPDATE_NVBUGS,
  FETCH_LIMIT,
  FETCH_NVBUGS_START,
  FETCH_NVBUGS_SUCCESS,
  FETCH_NVBUGS_ERROR,
  ADD_TABLE_FILTER,
  ADD_TABLE_SORT,
  CLEAR_FILTERS
} from './constants'

import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'

const addTableFilter = (prev, { key, val }) => {
  if (!prev[key]){
    return {
      ...prev,
      [key]: [val]
    }
  }
  return {
    ...prev,
    [key]: prev[key].concat(val)
  }
}
const addTableSort = (prev, { key, val }) => ({ [key]: val })
const clearFilters = () => ({})

const updateNvbugsData = (prev, { data }) => prev.concat(data)
const updateNvbugsEnd = (prev, { data }) => data.length < FETCH_LIMIT
const updateLoadingTrue = () => true
const updateLoadingFalse = () => false

const tableFilter = createReducer({}, {
  [ADD_TABLE_FILTER]: addTableFilter,
  [CLEAR_FILTERS]: clearFilters
})

const tableSort = createReducer({}, {
  [ADD_TABLE_SORT]: addTableSort,
  [CLEAR_FILTERS]: clearFilters
})

const data = createReducer([], {
  [UPDATE_NVBUGS]: updateNvbugsData
})

const end = createReducer(false, {
  [UPDATE_NVBUGS]: updateNvbugsEnd
})

const loading = createReducer(false, {
  [FETCH_NVBUGS_START]: updateLoadingTrue,
  [FETCH_NVBUGS_SUCCESS]: updateLoadingFalse,
  [FETCH_NVBUGS_ERROR]: updateLoadingFalse
})

export default combineReducers({
  data,
  end,
  loading,
  tableSort,
  tableFilter,
})
